module.exports = {
	"brokerInformation": {},
	"agencyInformation": {},
	"commissionInformation": {
		"assignee": "myself"
	},
	"generalInformation": {
		"taxClassification": "indiv"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/js/data/formStarterDataMinimal.json
// module id = 40
// module chunks = 0